import * as d3 from 'd3'
export default {
  methods: {

    verify_dataList(selection, stg) {

      let newDataSet = []
      let tblField = [
        {code: 'IDX',         format: 'num', value: stg.IDX,},
        {code: 'SEQ',         format: 'num', },
        {code: 'DIAGRAM',     format: '',    value: stg.DIAGRAM,},
        {code: 'STG_NO',      format: 'num', value: stg.STG_NO,},
        {code: 'STAGE',       format: '',    value: stg.STAGE,},
        {code: 'TYPE',        format: '', },
        {code: 'RELATION',    format: '',    value: this.CRT.mode,},
        {code: 'DATABASE',    format: '', },
        {code: 'SCHEMA',      format: '', },
        {code: 'NAME',        format: '', },
        {code: 'FILE_PATH',   format: '', },
        {code: 'EXCEL_SHEET', format: '', },
      ]
  
      let count = 0
      for(let i=0; i<=this.CRT.id; i++) {

        let data = {}
        if(!d3.select(`#FORM_NAME_${i}`).empty()) {
          tblField.forEach(d=> {
            if(d.value || d.value == 0) {
              data[d.code] = d.value
            } else {
              data[d.code] = d3.select(`#FORM_${d.code}_${i}`).empty() ? '' : d3.select(`#FORM_${d.code}_${i}`).text()
            }
            if(data[d.code] && d.format == 'num') data[d.code] = Number(data[d.code])
          })
          newDataSet.push(data)
          count++
        }
      }

      // Stroke Color
      let errorCnt = 0
      newDataSet.forEach(d=> {
        if(d.TYPE == 'Excel') {
          if(!(d.TYPE && d.NAME && d.FILE_PATH && d.EXCEL_SHEET)) errorCnt++
        } else {
          if(!(d.TYPE && d.DATABASE && d.SCHEMA && d.NAME)) errorCnt++
        }
      })


      // Verification ----------------------------------------------------------
      let message = []

      // if(count == 0) message[0] = {text: 'No data has been entered.'}
      if(errorCnt>0) message[0] = {text: `Not all ${errorCnt} input fields have been filled in.`}
      
      if(message.length > 0) {
        this.gmx_openPopup(selection, {type: 'Alert', msg: message})
      } else {
        this.save_DataList(newDataSet, stg)
      }
    },



    del_Data(seq) {
      d3.select(`#LIST_${seq}`).remove()

      for(let i=seq+1; i<=this.CRT.id; i++) {
        let item = d3.select(`#LIST_${i}`)
        if(!item.empty()) {
          let y = this.getNode(`#LIST_${i}`, 'y')
          item.transition().duration(300).attr('transform', `translate(0, ${y-80-(341)})`)
        }
      }
      this.CRT.count--
      this.reflash(this.CRT) // #####
    },
    

    
    save_DataList(newDataSet, stg) {
      // UPDATE
      this.tbl_Update(newDataSet, `IDX = '${stg.IDX}' AND RELATION = '${this.winProps.mode}'`).then(() => {
        this.db_Table = this.cbData.data
        
        this.close_Window()

        switch(this.CRT.mode) {
          case 'Input':
            d3.select(`#INPUT_LIST_${stg.STG_NO}`).remove()
            this.child_InputList(stg, newDataSet)
          break

          case 'Exec':
            d3.select(`#EXECUTION_LIST_${stg.STG_NO}`).remove()
            this.child_ExecList(stg, newDataSet)
          break

          case 'Output':
            d3.select(`#OUTPUT_LIST_${stg.STG_NO}`).remove()
            this.child_OutputList(stg, newDataSet)
          break
        }
      })
    },


  }
}